import {createCarousel} from "./create-carousel";

export function initWebHomeBannerCarousel()
{
    const root = document.querySelector('#hero-container.home-banner-carousel');
    if (!root || root.classList.contains('is-initialized')) {
        return;
    }

    const slides = root.querySelectorAll('.home-banner-carousel__slide');
    const slideCount = slides.length;
    if (!slideCount) {
        return;
    }

    const autoplayEnabled = String(root.dataset.autoplay) !== 'false' && slideCount > 1;
    const autoplaySpeed = parseInt(root.dataset.autoplaySpeed, 10) || 5000;
    let autoplayTimer = null;
    let api = null;

    const stopAutoplay = function() {
        if (autoplayTimer) {
            clearInterval(autoplayTimer);
            autoplayTimer = null;
        }
    };

    const startAutoplay = function() {
        if (!autoplayEnabled || autoplayTimer) {
            return;
        }
        autoplayTimer = setInterval(function() {
            if (!api) {
                return;
            }
            if (api.getIndex() >= api.getSlideCount() - 1) {
                api.scrollTo(0, false);
            } else {
                api.scrollNext();
            }
        }, autoplaySpeed);
    };

    const restartAutoplay = function() {
        if (!autoplayEnabled) {
            return;
        }
        stopAutoplay();
        startAutoplay();
    };

    const loadLazyImages = function(slide) {
        if (!slide) {
            return;
        }
        slide.querySelectorAll('img.home-banner-carousel__lazy[data-src]').forEach(function(img) {
            if (img.getAttribute('src')) {
                return;
            }
            img.src = img.dataset.src;
            img.removeAttribute('data-src');
            img.classList.remove('home-banner-carousel__lazy');
        });
    };

    const syncSwipe = function() {
        if (!api || typeof api.setAllowSwipe !== 'function') {
            return;
        }
        api.setAllowSwipe(window.innerWidth < 768);
    };

    api = createCarousel(root, {
        selectors: {
            viewport: '.home-banner-carousel__viewport',
            track: '.home-banner-carousel__track',
            slide: '.home-banner-carousel__slide',
            prev: '.home-banner-carousel__prev',
            next: '.home-banner-carousel__next',
            pagination: '.home-banner-carousel__pagination',
            paginationItem: '.home-banner-carousel__pagination-element'
        },
        loop: false,
        mode: 'percent',
        slidesPerView: 1,
        startIndex: 0,
        swipe: window.innerWidth < 768,
        suppressClickOnSwipe: true,
        arrows: {mode: 'toggle-hidden'},
        watchResize: true,
        onInit: function() {
            loadLazyImages(slides[0]);
            if (slides[1]) {
                loadLazyImages(slides[1]);
            }
            syncSwipe();
            startAutoplay();
        },
        onSelect: function(index) {
            loadLazyImages(slides[index]);
            if (slides[index + 1]) {
                loadLazyImages(slides[index + 1]);
            }
            restartAutoplay();
        }
    });

    if (!api) {
        return;
    }

    window.addEventListener('resize', syncSwipe);
    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);
}
